import { useEffect, useState } from "react";

import { ReactComponent as ClockCircleOutlined } from "../../assets/images/clockCircleOutlined.svg";
import { ReactComponent as Steps } from "../../assets/images/steps.svg";
import { ReactComponent as Close } from "../../assets/images/close.svg";
import { ReactComponent as Video } from "../../assets/images/video.svg";
import { ReactComponent as EggIcon } from "../../assets/images/dragon-fruifft.svg";
import { ReactComponent as StepsIcon } from "../../assets/images/steps.svg";
import { ReactComponent as SoundOutlined } from "../../assets/images/soundOutlined.svg";
import { ReactComponent as MutedOutlined } from "../../assets/images/mutedOutlined.svg";

import { mode2List, mode3List, sounds } from "../../utils/constants";
import { openRewardedVideo } from "../../utils/helpers";
import ControlPanel from "../ControlPanel";
import useIsWindowVisible from "../../hooks/useIsWindowVisible";
import RewardPopup from "../RewardPopup";

let timerInterval;
const RoundInfo = ({
	stepCount,
	isPlayed,
	winInfo,
	onChangeCount,
	onChangeMode,
	count,
	closeGame,
	mode,
	isLocked,
	openAll,
	youIsWin,
	setYouIsWin,
}) => {
	const [openReward, setOpenReward] = useState(false);
	const isWindowVisible = useIsWindowVisible();
	const [time, setTime] = useState(0);
	const [isOnSound, setIsOnSound] = useState(false);
	const [advStarted, setAdvStarted] = useState(false);

	useEffect(() => {
		const soundOn = isWindowVisible && window.localStorage.getItem("soundOn") !== "false";

		if (soundOn) {
			setIsOnSound(true);
			window.localStorage.setItem("soundOn", "true");
			sounds.backgroundPlay.play();
		} else {
			sounds.backgroundPlay.stop();
		}
	}, [isWindowVisible]);

	const toggleSound = () => {
		setIsOnSound((prev) => {
			if (prev) {
				sounds.backgroundPlay.stop();
			} else {
				sounds.backgroundPlay.play();
			}
			window.localStorage.setItem("soundOn", `${!prev}`);
			return !prev;
		});
	};

	useEffect(() => {
		clearTimeout(timerInterval);
		if (isPlayed) {
			let hours = 0;
			let minutes = 0;
			let seconds = 1;

			function updateClock() {
				const formattedTime = `${hours > 0 ? `${hours}:` : ""}${String(minutes).padStart(2, "0")}:${String(
					seconds
				).padStart(2, "0")}`;

				setTime(formattedTime);
				winInfo.current.time = formattedTime;

				seconds++;

				if (seconds === 60) {
					seconds = 0;
					minutes++;
				}
				if (minutes === 60) {
					minutes = 0;
					hours++;
				}
			}

			timerInterval = setInterval(updateClock, 1000);
		} else {
			setTime("00:00");
		}
	}, [isPlayed]);

	useEffect(() => {
		winInfo.current.steps = stepCount;
	}, [stepCount]);

	const showReward = () => {
		if (window.sdk?.adv) {
			setAdvStarted(true);
			openRewardedVideo({
				openCallback: () => setOpenReward(false),
				onRewarded: () => openAll(),
				closeCallback: () => setAdvStarted(false),
				errorCallback: () => setAdvStarted(false),
			});
		}
	};

	return (
		<div className="round-info">
			{openReward && (
				<RewardPopup type={"openAll"} onClose={() => setOpenReward(false)} showReward={showReward} />
			)}

			{youIsWin ? (
				<div className="win-popup">
					<div>
						<h2>
							<StepsIcon />
							<span style={{ flexGrow: 1 }}>{winInfo.current.steps}</span>
						</h2>
						<h2>
							<ClockCircleOutlined />
							<span style={{ flexGrow: 1 }}>{winInfo.current.time}</span>
						</h2>
					</div>
					<button className="win-popup-close" onClick={() => setYouIsWin(false)}>
						<Close />
					</button>
				</div>
			) : (
				<>
					{isPlayed ? (
						<div className="">
							<div className="round-info-top">
								<div className="">
									<ClockCircleOutlined style={{ fontSize: 36, color: "#442418" }} />
									<span className="time">{time}</span>
								</div>
								<div className="">
									<Steps />
									<span className="step-count">{stepCount}</span>
								</div>
							</div>
							<div className="round-info-bottom">
								<button className="control-btn-restart" onClick={closeGame}>
									<Close />
								</button>
								<button
									className="adversting-btn"
									disabled={advStarted}
									onClick={() => setOpenReward(true)}>
									<span className="adversting-egg">
										<EggIcon />
									</span>
									<Video />
									<span className="adversting-egg _open"></span>
								</button>
								<button className="sound-btn" onClick={toggleSound}>
									{isOnSound ? <SoundOutlined /> : <MutedOutlined style={{ opacity: 0.7 }} />}
								</button>
							</div>
						</div>
					) : (
						<div className="menu">
							<ControlPanel
								onChangeCount={onChangeCount}
								isPlayed={isPlayed}
								count={count}
								toggleSound={toggleSound}
								isOnSound={isOnSound}
								isLocked={isLocked}
							/>

							<div className="mode-levels">
								{(count === "2" ? mode2List : mode3List).map((item) => (
									<button
										key={item.value}
										className={`control-btn ${mode === item.value ? "selected" : ""} ${
											isPlayed ? "played" : ""
										}`}
										onClick={() => onChangeMode(item.value)}>
										{item.value}
									</button>
								))}
							</div>
						</div>
					)}
				</>
			)}
		</div>
	);
};

export default RoundInfo;
